module.exports = __webpack_public_path__ + "img/2.f9e1656a.png";